import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getPagination = (state) => get(state, 'providers.list.pagination', {});
export const getFilters = (state) => get(state, 'providers.list.filters', {});

export const getProvidersIds = (state) => get(state, 'providers.list.result.providers', []);
export const getProviders = (state) => get(state, 'providers.list.entities.providers', []);

export const getIsLoading = (state) => get(state, 'providers.list.isLoading', false);
export const getNeedFetch = (state) => get(state, 'providers.list.needFetch', false);

export const getIsFetching = (state) => get(state, 'providers.form.isFetching', false);
export const getIsFetchingConfig = (state) => get(state, 'providers.form.isFetchingConfig', false);
export const getIsSaving = (state) => get(state, 'providers.form.isSaving', false);
export const getEditing = (state) => get(state, 'providers.form.editing', false);

export const getVisibleProviders = createSelector(
  [getProvidersIds, getProviders],
  (ids, providers) => ids.map((id) => providers[id]).filter((provider) => !provider.deleted)
);



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/selectors/providers_selectors.js